<kendo-splitter style="width: 100%; height: 100%" orientation="horizontal">
  <kendo-splitter-pane style="overflow-y: hidden">
    <video
      [title]="active?.title"
      (ended)="onVideoEnd($event)"
      style="height: 100%"
      #video
      class="app-video-zone"
      controls
      preload="auto"
      playsinline
    >
      <source [src]="safeUrl(active)" [type]="active?.mimeType" />
    </video>
  </kendo-splitter-pane>

  <kendo-splitter-pane
    *ngIf="videos?.length > 1"
    class="overflow-x-hidden"
    [collapsible]="true"
    size="25%"
    min="25%"
    max="25%"
  >
    <div class="app-play-list-header">Очередь воспроизведения</div>
    <tk-filebox
      [ngModel]="videos"
      [autoUpload]="false"
      [readonly]="true"
      [showFileList]="true"
      (activated)="onFileActivate($any($event))"
      (selected)="onFileSelect($any($event))"
      (actionFailed)="onFileActionError($any($event))"
    >
      <ng-container tkFileBoxTemplates>
        <ng-template kendoUploadFileTemplate let-files>
          <tk-file-entry
            class="app-file-select__file"
            [class.app-file-select__file_active]="isActive(files[0])"
            [file]="files[0]"
          >
          </tk-file-entry>
        </ng-template>
        <ng-template tkFileCardTemplate let-file>
          <span class="k-file-name" [title]="file.name">{{ file.title }}</span>
          <div class="app-file-info">
            <span class="k-file-size">{{ file.size | fileSize }}</span>
            <span class="badge bg-secondary app-file-extension">{{ file.extension }}</span>
          </div>
        </ng-template>
      </ng-container>
    </tk-filebox>
  </kendo-splitter-pane>
</kendo-splitter>
